export default "__VITE_ASSET__huV5YHcV__"